// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"steps_Wrapper__Dv887","Step":"steps_Step__i0mc5","Active":"steps_Active____cBQ"};